import React from 'react';
import { XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { painPoints } from '../data/salesContent';
export function PainSection() {
  return <section className="w-full bg-ink-800 py-16 sm:py-20" aria-labelledby="pain-title" style={{
    paddingBottom: "0px"
  }} data-id="element-135" data-mp="2uy5o34cnt60n">
      <div className="mx-auto max-w-3xl px-5" data-id="element-136" data-mp="2yz7npmahnk35">
        <h2 id="pain-title" className="text-center font-display text-[1.7rem] font-bold leading-tight text-white sm:text-4xl" data-id="element-137" data-mp="2yxxogtrwg5ux">
          How many more times are you going to cross your legs and{' '}
          <span className="text-lilac-400" data-id="element-138" data-mp="2q0dm1hiaw3iq">hope for the best?</span>
        </h2>

        <p className="mx-auto mt-6 max-w-2xl text-center text-[17px] leading-relaxed text-body" data-id="element-139" data-mp="2bbhcth4ickgj">
          You've done the Kegels. You've googled the exercises. And yet — the moment you
          laugh too hard or try to run, your body reminds you it still isn't fixed.
        </p>
        <p className="mt-4 text-center text-lg font-semibold text-lilac-200" data-id="element-140" data-mp="278um5jjkp5kx">
          It's not your fault. Generic Kegel advice is not a system.
        </p>

        <ul className="mx-auto mt-10 max-w-2xl space-y-2.5" data-id="element-141" data-mp="3nlflgbqjx22s">
          {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-xl border border-white/5 bg-ink-700 px-4 py-3.5" data-id="element-142" data-mp="3nnic8xzj2z8k">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" strokeWidth={3} aria-hidden="true" data-id="element-143" data-mp="gzeaz157cf7" />
              <span className="text-[15px] leading-relaxed text-body" data-id="element-144" data-mp="38w9mmovmldvf">{point}</span>
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-2xl font-bold italic text-white sm:text-3xl" data-id="element-145" data-mp="33y7tfb4hjy68">
          What if this was the last week you lived like this?
        </p>

        <div className="mt-8 flex justify-center" data-id="element-146" data-mp="3dvw1f2r3r26c">
          <CtaButton data-id="element-147" data-mp="3du1gvpjqtc2s" />
        </div>
      </div>
    </section>;
}